import { render } from "./recordModal.vue?vue&type=template&id=28c0ac01&scoped=true"
import script from "./recordModal.vue?vue&type=script&lang=js"
export * from "./recordModal.vue?vue&type=script&lang=js"

import "./recordModal.vue?vue&type=style&index=0&id=28c0ac01&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c0ac01"]])

export default __exports__